import React from "react";
import NewsTitleAdmin from "./NewsTitleAdmin";
import Pagination from "../components/Pagination";
import '../styles/NewsListAdmin.css';

export const AdminNewsTableSkeleton = ({ count = 10 }) => (
  <tbody className="admin-news-skeleton" aria-label="Завантаження новин">
    {Array.from({ length: count }).map((_, rowIndex) => (
      <tr key={rowIndex}>
        {Array.from({ length: 7 }).map((__, cellIndex) => (
          <td key={cellIndex}>
            <span
              className={`admin-news-skeleton-line ${
                cellIndex === 0 ? 'title' : ''
              } ${cellIndex === 6 ? 'actions' : ''}`}
            />
          </td>
        ))}
      </tr>
    ))}
  </tbody>
);

const NewsListAdmin = ({
  newsList,
  onEdit,
  onDelete,
  initialLoading = false,
  pageLoading = false,
  isRefreshing = false,
  currentPage = 1,
  totalPages = null,
  hasNext = false,
  onPageChange,
}) => {
  const getDateParts = (news) => {
    if (news?.day && news?.month && news?.year) {
      const pad = (n) => String(n).padStart(2, '0');

      return {
        date: `${pad(news.day)}.${pad(news.month)}.${news.year}`,
        time: news.time || '',
      };
    }

    const ts = news?.publishedAt;

    if (!ts) {
      return { date: '', time: '' };
    }

    let d = null;

    if (typeof ts.toDate === 'function') {
      d = ts.toDate();
    } else if (ts.seconds) {
      d = new Date(ts.seconds * 1000);
    } else if (ts instanceof Date) {
      d = ts;
    } else if (typeof ts === 'number') {
      d = new Date(ts);
    }

    if (!d || isNaN(d)) {
      return { date: '', time: '' };
    }

    const pad = (n) => String(n).padStart(2, '0');

    return {
      date: `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`,
      time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
    };
  };

  return (
    <div aria-busy={initialLoading || pageLoading || isRefreshing}>
      <div className="panel">
        <h1>Список новин</h1>
      </div>

      <table className="news-table">
        <thead>
          <tr>
            <th>Заголовок</th>
            <th>Категорія</th>
            <th>Розділ</th>
            <th>Автор</th>
            <th>Дата</th>
            <th>Час</th>
            <th>Дії</th>
          </tr>
        </thead>

        {((initialLoading || pageLoading) && newsList.length === 0) ? (
          <AdminNewsTableSkeleton />
        ) : (
          <tbody>
            {newsList.map((news) => {
              const { date, time } = getDateParts(news);

              return (
                <tr key={news.id}>
                <td>
                  <NewsTitleAdmin news={news} />
                </td>

                <td>{news.category || "Немає категорії"}</td>

                <td>
                  {Array.isArray(news.sections) && news.sections.length > 0
                    ? news.sections.join(", ")
                    : "Немає розділу"}
                </td>

                <td>{news.author || "Невідомий"}</td>

                <td>{date}</td>

                <td>{time}</td>

                <td>
                  <button
                    className="button edit-button"
                    onClick={() => onEdit(news)}
                  >
                    Редагувати
                  </button>

                  {onDelete && (
                    <button
                      className="button delete-button"
                      onClick={() => onDelete(news.id)}
                    >
                      Видалити
                    </button>
                  )}
                </td>
                </tr>
              );
            })}
          </tbody>
        )}
      </table>

      {!initialLoading && (currentPage > 1 || hasNext || (totalPages || 0) > 1) && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          hasNext={hasNext}
          onPageChange={onPageChange}
          disabled={pageLoading || isRefreshing}
          sequential
          pageType="admin_news"
          compact
        />
      )}
    </div>
  );
};

export default NewsListAdmin;
